import { Injectable } from '@angular/core';
import { VibrationsChart } from '@shared/models/charts/VibrationsChart';

@Injectable({
  providedIn: 'root'
})
export class ChartUtilsService {

  constructor() { }

  /**
   * Calcule un stepSize dynamique pour l'affichage des ticks sur l'axe X des graphiques
   * @param vibrations - Les données de vibration
   * @param channelIndex - L'index du canal
   * @returns stepSize en millisecondes
   */
  calculateDynamicStepSize(vibrations: VibrationsChart, channelIndex: number): number {
    const totalDurationMs = (vibrations?.signalDataEntity?.signalData?.channels[channelIndex].timeSpectrum.values.length / 2048) * 1000;
    const targetTickCount = 8;
    let dynamicStepSize = Math.ceil(totalDurationMs / targetTickCount);
    
    // Arrondir à des valeurs lisibles
    if (dynamicStepSize <= 50) dynamicStepSize = 50;
    else if (dynamicStepSize <= 100) dynamicStepSize = 100;
    else if (dynamicStepSize <= 200) dynamicStepSize = 200;
    else if (dynamicStepSize <= 500) dynamicStepSize = 500;
    else if (dynamicStepSize <= 1000) dynamicStepSize = 1000;
    else dynamicStepSize = Math.ceil(dynamicStepSize / 1000) * 1000;
    
    return dynamicStepSize;
  }
}